import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useRoute } from "vue-router";
import PlantInfo from "@/components/plant/PlantInfo.vue";
import AppPageHeader from "@/components/app/AppPageHeader.vue";
import { ref } from "vue";
import { updatePageTitle } from "@/helpers/tools";


export default /*#__PURE__*/_defineComponent({
  __name: 'PlantInfoView',
  setup(__props) {

const route = useRoute()

const header = ref<string>('')

function onPlantNameUpdated (plantName: string) {
  header.value = plantName
  updatePageTitle(`Plant: ${plantName}`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppPageHeader, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(header.value), 1)
      ]),
      _: 1
    }),
    _createVNode(PlantInfo, {
      "plant-id": _unref(route).params.id,
      "plant-name": header.value,
      "onUpdate:plantName": onPlantNameUpdated
    }, null, 8, ["plant-id", "plant-name"])
  ], 64))
}
}

})